import sysend from 'sysend';

/**
 * This function initializes synchronization by setting up event listeners and a serializer for data
 * exchange.
 */
export const init_synchronization = async synchronization_fn => {
  window.addEventListener('load', () => {
    sysend.serializer(
      data => {
        if (data) {
          return JSON.stringify(data);
        }
      },
      string => {
        if (string) {
          return JSON.parse(string);
        }
      }
    );

    sysend.on('wp:session:reload', async data => {
      // console.log('Synchronization message received with data: ', data);

      if (data.token) {
        await synchronization_fn.call(null, data.token);
      }
    });
  });
};

/**
 * This function removes synchronization for a session reload event.
 */
export const remove_syncronization = () => {
  sysend.off('wp:session:reload');
};

/**
 * This function initializes debugging for synchronization events in JavaScript.
 */
export const init_synchronization_debug = () => {
  const handler = event => {
    console.log(event);
  };

  sysend.track('open', handler);
  sysend.track('close', handler);
  sysend.track('message', handler);
};

/**
 * This function broadcasts a message to reload a session with a given token.
 */
export const broadcast_reload_message = token => {
  const data = { token: token };

  // console.log('Sending synchronization message with data: ', data);
  sysend.broadcast('wp:session:reload', data);
};

/**
 * The function sends a reload message to a specified URL and broadcasts a token.
 * @param url - The `url` parameter is a string that represents the URL of the target server to which a
 * reload message will be sent.
 * @param token - The token parameter is likely a security token or authentication token that is used
 * to verify the identity of the user or application making the request. It may be used to authorize
 * access to certain resources or actions on the server.
 */
export const send_reload_message_to = (url, token) => {
  console.log({ token, url });
  sysend.proxy(url);
  broadcast_reload_message(token);
};
